import React, { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import Button from '@mui/material/Button';
import { makeStyles } from '@material-ui/styles';
import DeleteIcon from '@mui/icons-material/Delete';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FolderIcon from '@mui/icons-material/Folder';
import { maxWidth } from '@mui/system';
import ButtonBase from '@mui/material/ButtonBase';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Divider from '@mui/material/Divider';
import { Link } from 'react-router-dom';

import SwapVertIcon from '@mui/icons-material/SwapVert';

import secureAxios from '../../secureAxios';
import IBackdrop from '../backdrop.js';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import TextField from '@mui/material/TextField';

import ListItemButton from '@mui/material/ListItemButton';
import WalletIcon from '@mui/icons-material/Wallet';

import Web3 from "web3";

import web3ModalConfig from "../../providerOption";
import { ethers } from 'ethers';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import InputLabel from '@mui/material/InputLabel';

import usdtlogo from '../../assets/usdt.png'
import slplogo from '../../assets/slp.png'
import xeclogo from '../../assets/xec.png'
import jasmylogo from '../../assets/jasmy.png'


import vetlogo from '../../assets/vet.png'
import openlogo from '../../assets/open.png'
import winlogo from '../../assets/win.png'
import _metaland from '../../assets/Metaland.png';
import xunlogo from '../../assets/xun.png';
import trxlogo from '../../assets/trx.png';

import Menu from '@mui/material/Menu';

import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';



function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}




const abi = [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"assetProtectionRole","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"paused","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"betaDelegateWhitelister","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"proposedOwner","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"EIP712_DOMAIN_HASH","outputs":[{"name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"supplyController","outputs":[{"name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"currentOwner","type":"address"},{"indexed":true,"name":"proposedOwner","type":"address"}],"name":"OwnershipTransferProposed","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldProposedOwner","type":"address"}],"name":"OwnershipTransferDisregarded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldOwner","type":"address"},{"indexed":true,"name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[],"name":"Pause","type":"event"},{"anonymous":false,"inputs":[],"name":"Unpause","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"AddressFrozen","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"AddressUnfrozen","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"addr","type":"address"}],"name":"FrozenAddressWiped","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldAssetProtectionRole","type":"address"},{"indexed":true,"name":"newAssetProtectionRole","type":"address"}],"name":"AssetProtectionRoleSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"SupplyIncreased","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"SupplyDecreased","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldSupplyController","type":"address"},{"indexed":true,"name":"newSupplyController","type":"address"}],"name":"SupplyControllerSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"},{"indexed":false,"name":"seq","type":"uint256"},{"indexed":false,"name":"fee","type":"uint256"}],"name":"BetaDelegatedTransfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldWhitelister","type":"address"},{"indexed":true,"name":"newWhitelister","type":"address"}],"name":"BetaDelegateWhitelisterSet","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"newDelegate","type":"address"}],"name":"BetaDelegateWhitelisted","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"oldDelegate","type":"address"}],"name":"BetaDelegateUnwhitelisted","type":"event"},{"constant":false,"inputs":[],"name":"initialize","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"initializeDomainSeparator","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_proposedOwner","type":"address"}],"name":"proposeOwner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"disregardProposeOwner","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"claimOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"reclaimBUSD","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"pause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"unpause","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_newAssetProtectionRole","type":"address"}],"name":"setAssetProtectionRole","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"freeze","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"unfreeze","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"wipeFrozenAddress","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"isFrozen","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_newSupplyController","type":"address"}],"name":"setSupplyController","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"increaseSupply","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_value","type":"uint256"}],"name":"decreaseSupply","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"target","type":"address"}],"name":"nextSeqOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"sig","type":"bytes"},{"name":"to","type":"address"},{"name":"value","type":"uint256"},{"name":"fee","type":"uint256"},{"name":"seq","type":"uint256"},{"name":"deadline","type":"uint256"}],"name":"betaDelegatedTransfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"r","type":"bytes32[]"},{"name":"s","type":"bytes32[]"},{"name":"v","type":"uint8[]"},{"name":"to","type":"address[]"},{"name":"value","type":"uint256[]"},{"name":"fee","type":"uint256[]"},{"name":"seq","type":"uint256[]"},{"name":"deadline","type":"uint256[]"}],"name":"betaDelegatedTransferBatch","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_addr","type":"address"}],"name":"isWhitelistedBetaDelegate","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_newWhitelister","type":"address"}],"name":"setBetaDelegateWhitelister","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"whitelistBetaDelegate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"_addr","type":"address"}],"name":"unwhitelistBetaDelegate","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}]

const coins = [{name: 'USDT', details: 'https://bscscan.com/token/0x55d398326f99059ff775485246999027b3197955?a=0x15bB295507D8AFF2ec2DD97f54DA41be4a3499d1'},
{name: 'XEC', details: 'https://bscscan.com/token/0x0ef2e7602add1733bfdb17ac3094d0421b502ca3?a=0x15bB295507D8AFF2ec2DD97f54DA41be4a3499d1'},
{name: 'JASMY', details: 'https://bscscan.com/token/0x15669cf161946c09a8b207650bfbb00e3d8a2e3e?a=0x15bB295507D8AFF2ec2DD97f54DA41be4a3499d1'},
{name: 'SLP', details: 'https://bscscan.com/token/0x15669cf161946c09a8b207650bfbb00e3d8a2e3e?a=0x15bB295507D8AFF2ec2DD97f54DA41be4a3499d1'}]

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  });
  
const getLogo = {
  usdt: usdtlogo,
  vet: vetlogo,
  open: openlogo,
  win: winlogo,
  metaland: _metaland,
  xun: xunlogo,
  trx: trxlogo
  
}

const formattedName = {
  usdt: "USDT",
  vet: 'VET',
  open: 'OPEN',
  win: "WIN",
  metaland: "METALAND",
  xun: "XUN Protocol",
  trx: "Tron"
}

const _coin_rates = {'usdt': '1','vet': '0','open': '0','win': '0', 'xun': 0, 'trx': 0}
  

  const data = {
      'miningCapital': '0',
      'lockedCapital': '0',
      'availableCapital': '0',
      'totalReward': '0',
      'rewards': {
        directReward: '0',
        miningReward: '0',
        mintingReward: '0'
      },
      teamRewadrs:[
        {'coin_name': 'USDT', 'amount': 0},
        {'coin_name': 'VET', 'amount': 0},
        {'coin_name': 'OPEN', 'amount': 0},
        {'coin_name': 'WIN', 'amount': 0}
      ],
      availableBalances:[
        {'coin_code': 'USDT', 'balance': 0},
        {'coin_code': 'VET', 'balance': 0},
        {'coin_code': 'OPEN', 'balance': 0},
        {'coin_code': 'WIN', 'balance': 0}
      ],
      'balance': '0',
      'withdrawnAmount': '0'
  }

  const profileSummary = {
    teamCount: 5,
    totalStake: '30.000 HZR',
    rewards: 22.208,
    totalRewardinDollar: 477.703,
    withdrawl: 27.710,
    withdrawlUSD: 590.051
  }

  const rewards = ['Direct Reward', 'Reward Point', 'Minting Reward'];
  
  const profileSummaryTexts = ['My Team', 'My Stakeing', 'Total Rewards', 'Total Rewards (USD)', 'Total Withdrawals', 'Total Withdrawals (USD)']

  function generate(element) {
      return [0, 1, 2].map((value) =>
        React.cloneElement(element, {
          key: value,
        }),
      );
    }
  
    const Demo = styled('div')(({ theme }) => ({
      backgroundColor: 'transparent',
    }));
  
  
    const useStyles = makeStyles(theme => ({
      root: {
        height: '100%',
        borderBottomRightRadius: '40px',
        borderRadius: '5px'
      },
      content: {
        alignItems: 'center',
        display: 'flex'
      },
      title: {
        fontWeight: 'bold',
        color: 'rgb(33, 43, 54)'
      },
      subItemtitle: {
        color: 'rgb(33, 43, 54)',
        opacity: '0.6',
        fontSize: '8px'
      },
      
      icon: {
        height: 32,
        width: 32
      },
      cardBackground: {
        backgroundColor: '#f0f5f9',
        maxWidth: '300px'
        //padding: 2
      },
      progressBar:{
        width: '50%',
        maxWidth: '200px',
        margin: 'auto'
      },
      pan: {
        boxShadow:  'rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px;',
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
        background: 'rgb(255, 255, 255)'
      }
    }));

    const text = {
        color: "rgb(33, 43, 54)",
        opacity: '0.7',
        fontSize: '11px',
        maxWidth: '150px'
    };

    const subItemtitle = {
      color: 'rgb(33, 43, 54)',
      fontSize: '13px'
    };
  
  const Swap = (props) => {
      const { className, tileDilogue, onClicked, ...rest } = props;
      const classes = useStyles();
      
      const [coin_code, setCoinCOde] = React.useState('usdt');
      const [dense, setDense] = React.useState(false);
      const [from_coin, setFromCoin] = React.useState('vet');
      const [to_coin, setToCoin] = React.useState('usdt');
      const [from_amount, setFromAmount] = React.useState(0.00);
      const [to_amount, setToAmount] = React.useState(0.00);
      const [fee, setFee] = React.useState(5);
      const [coin_rates, setCoinrates] = React.useState(_coin_rates)
      const [to_balance, setToBalance] = React.useState(0.00);
      const [from_balance, setFrombalance] = React.useState(0.00);
      const [balances, setBalances] = React.useState([]);
      const [profileSummary, setprofileSummary] = React.useState({});
      const [userDetails, setUserDetails] = React.useState({});
      const [open, setOpen] = React.useState(false);
      const [anchorEl, setAnchorEl] = useState(null);
      const [selectedValue, setSelectedValue] = useState('');
      const [isOpenMenu, setisOpenMenu] = useState(false);
      const [pin, setPin] = React.useState('');
      const [stakedialogopen, setStakeDialogOpen] = React.useState(false);
      const [value, setValue] = React.useState(-1);

      const handleChange = (event, newValue) => {
        setValue(-1);
        window.open(coins[newValue]?.details)
      };

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        setisOpenMenu(true);
      };

      const handleClose = () => {
        setAnchorEl(null);
        setisOpenMenu(false);
        setStakeDialogOpen(false);
      };

      const handleMenuItemClick = (value, type_of) => {
        setSelectedValue(value);
        handleClose();
        const _balance = userDetails?.coins.filter((item) => item?.coin_code.toLowerCase() === value)
        if (type_of === 'to'){
          setToCoin(value);
          setToBalance(parseFloat(_balance[0]?.balance).toFixed(6));
        }
        else{
          setFromCoin(value);
          setFrombalance(parseFloat(_balance[0]?.balance).toFixed(6));
        }
      };

      const Profiledetails = () => {
        setOpen(true);
        secureAxios
            .get(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/userinfo`).then(response => {
              setOpen(false);
              if (response.data?.user){
                setUserDetails(response.data?.user);
                setCoinrates(response.data?.user?.coin_rates)
                const from_balance = response.data?.user?.coins.filter((item) => item?.coin_code.toLowerCase() === from_coin)
                const to_balance = response.data?.user?.coins.filter((item) => item?.coin_code.toLowerCase() === to_coin)
                let decreasedBalanceTo = 0;
                let decreasedBalanceFrom = 0
                if (to_balance[0]?.balance > 0){
                  decreasedBalanceTo = parseFloat(to_balance[0]?.balance) - 0.000001;
                }
                if (from_balance[0]?.balance > 0){
                  decreasedBalanceFrom = parseFloat(from_balance[0]?.balance) - 0.000001;
                }


                setToBalance(decreasedBalanceTo.toFixed(6));
                setFrombalance(decreasedBalanceFrom.toFixed(6));
              }
            }).catch(error => {
              setOpen(false);
            })
      }

      const SwapCoin = () => {
        setOpen(true);
        setStakeDialogOpen(false);
        secureAxios
            .post(`${process.env.REACT_APP_SERVICE_PYTHON_API_URL}/user/swap_coin`, {from_amount: from_amount, to_coin: to_coin, from_coin: from_coin, pin: pin}).then(response => {
              if (response.data){
                setOpen(false);
                alert("Swap Successfull")
                Profiledetails();
              }
            }).catch(error => {
              if (error.response.data?.non_field_errors){
                alert(error.response.data?.non_field_errors)
              }
              else{
                alert(error.response.data?.detail)
              }
              setOpen(false);
            })
      }

      React.useEffect(() => {
        Profiledetails()
        return
      }, []);



      

      const swap = () => {
        return false;
        const from = from_coin;
        const to = to_coin;
        setFromCoin(to);
        setToCoin(from_coin);

        if (from === 'usdt'){
          // Recalculate amounts after swapping coins
          const newToAmount = calculateConversion(from_amount, from, to, coin_rates);
          setFromAmount(newToAmount);
          setToAmount(from_amount);
        }
        if (to === 'usdt'){
          // Recalculate amounts after swapping coins
          const newFromAmount = calculateConversion(to_amount, to, from, coin_rates);
          setFromAmount(to_amount);
          setToAmount(newFromAmount);
        }
        

        const from_balance = userDetails?.coins.filter((item) => item?.coin_code.toLowerCase() === to)
        const to_balance = userDetails?.coins.filter((item) => item?.coin_code.toLowerCase() === from)

        let decreasedBalanceTo = parseFloat(to_balance[0]?.balance) - 0.000001;
        let decreasedBalanceFrom = parseFloat(from_balance[0]?.balance) - 0.000001;


        setToBalance(decreasedBalanceTo.toFixed(6));
        setFrombalance(decreasedBalanceFrom.toFixed(6));

      }

      const calculateConversion = (amount, fromCoin, toCoin, rates) => {
        if (fromCoin === 'usdt') {
          return (rates[fromCoin] * amount) / rates[toCoin] || 0;
        } else {
          return rates[fromCoin] * amount || 0;
        }
      };
      
      const handleFromAmount = (event) => {
        const inputAmount = parseFloat(event.target.value) || 0;
        setFromAmount(inputAmount);
        setToAmount(calculateConversion(inputAmount, from_coin, to_coin, coin_rates));
      };
      
      const handleToAmount = (event) => {
        const inputAmount = parseFloat(event.target.value) || 0;
        setToAmount(inputAmount);
        setFromAmount(calculateConversion(inputAmount, to_coin, from_coin, coin_rates));
      };

      const handleFromMaxBalance = () => {
        setFromAmount(from_balance);
        setToAmount(calculateConversion(from_balance, from_coin, to_coin, coin_rates));

      }

      const handleToMaxBalance = () => {
        setToAmount(to_balance);
        setFromAmount(calculateConversion(to_balance, to_coin, from_coin, coin_rates));
      }
      
      return (
      <>
      <IBackdrop isOpen={open} msg={"Signin progress"}/>

       <Paper
       className={classes.pan}
       style={{background: 'rgb(24, 26, 32)'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                <List dense={dense}>
                  <ListItem
                      secondaryAction={
                        <>
                          <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <IconButton
                              edge="end"
                              aria-label="max-balance"
                              onClick={handleFromMaxBalance}
                              style={{ color: '#fff', alignSelf: 'flex-end', marginTop: '-15px' }}
                            >
                              <WalletIcon style={{height: '15px'}} /><Typography>{from_balance}</Typography>
                            </IconButton>
                            <input
                              onChange={handleFromAmount}
                              value={from_amount}
                              style={{
                                padding: '20px 5px',
                                fontSize: '15px',
                                width: '120px',
                                marginTop: '-15px',
                                textAlign: 'right',
                                background: 'transparent',
                                outline: 0,
                                border: '0px',
                                color: '#fff',
                              }}
                              placeholder='Amount'
                            />
                          </div>
                        </>
                      }
                    >
                        <ListItemAvatar>
                          <Avatar onClick={handleClick} style={{background: 'transparent'}}>
                              <img style={{width: 40}} src={getLogo[from_coin]} alt="fireSpot"/>
                          </Avatar>
                        </ListItemAvatar>

                        <ListItemButton
                          className={classes.title}
                          dense={dense}
                          onClick={handleClick}
                        >
                          <div style={{display:'flex', flexDirection: 'row', marginTop: '11px'}}>
                            <Typography onClick={handleClick} style={{color: 'rgb(33, 43, 54)', fontSize: 18, cursor: 'pointer', display: 'flex', flexDirection:'row'}} variant="subtitle2">
                              {formattedName[from_coin]}
                            </Typography>
                            {from_coin != 'usdt' && <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 18, cursor: 'pointer', lineHeight: '40px', marginLeft: '10px'}} variant="subtitle2">
                              <ExpandMoreIcon />
                            </Typography>}
                          </div>
 
                        </ListItemButton>
                    </ListItem>

                </List>
                    

                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Avatar onClick={swap} style={{background: 'transparent', cursor: 'pointer', border: '1px solid rgb(252, 213, 53)', height: '30px', margin: '10px auto', width: '30px', marginTop: '-10px'}}>
          <SwapVertIcon style={{height: '30px', width: '80px'}}/>
      </Avatar>


      <Paper
       className={classes.pan}
       style={{background: 'rgb(24, 26, 32)', marginTop: '-20px'}}
        sx={{
          p: 2,
          margin: 'auto',
          maxWidth: 500,
          flexGrow: 1
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Demo>
                <List dense={dense}>

                    <ListItem
                      secondaryAction={
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <IconButton
                              edge="end"
                              aria-label="max-balance"
                              onClick={handleToMaxBalance}
                              style={{ color: '#fff', alignSelf: 'flex-end', marginTop: '-15px' }}
                            >
                              <WalletIcon style={{height: '15px'}} /><Typography>{to_balance}</Typography>
                            </IconButton>
                          <input onChange={handleToAmount} value={to_amount} style={{padding: '20px 5px', fontSize: '15px', width: '120px', textAlign: 'right', background: 'transparent', outline: 0, border: '0px', color: '#fff'}} placeholder='Amount' />
                        </div>
                      }
                    >
                        <ListItemAvatar>
                          <Avatar style={{background: 'transparent'}}>
                              <img style={{width: 40}} src={getLogo[to_coin]} alt="fireSpot"/>
                          </Avatar>
                        </ListItemAvatar>

                        <ListItemButton
                          className={classes.title}
                          dense={dense}
                        >
                          <div style={{display:'flex', flexDirection: 'row', marginTop: '11px'}}>
                            <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 18, cursor: 'pointer', display: 'flex', flexDirection:'row'}} variant="subtitle2">
                              {formattedName[to_coin]}
                            </Typography>
                            {to_coin != 'usdt' && <Typography onClick={handleClick} style={{color: 'rgb(33, 43, 54)', fontSize: 18, cursor: 'pointer', lineHeight: '40px', marginLeft: '10px'}} variant="subtitle2">
                              <ExpandMoreIcon/>
                            </Typography>}
                          </div>
 
                        </ListItemButton>
                    </ListItem>

                </List>
                    

                </Demo>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Paper
       className={classes.pan}
       style={{background: 'transparent', marginTop: '30px'}}
        sx={{
          p: 0,
          margin: 'auto',
          maxWidth: 525,
          flexGrow: 1
        }}
      >
      <Typography style={{color: 'rgb(33, 43, 54)', fontSize: 12, 
          marginBottom: '25px'}} variant="subtitle2">
            Slippage Tolerance : {fee}%
      </Typography>

          <Button className='button_swap' style={{
              borderRadius: 2,
              marginTop: '0px',
              padding: '10px 0px',
              background: 'rgb(252, 213, 53)',
              fontWeight: 'bold',
              backgroundColor: "rgb(252, 213, 53) ",
              fontSize: "14px",
              border: '0.5px solid rgb(33, 43, 54)',
              marginBottom: '0px',
              width: '100%'
          }} variant="contained" onClick={() => {setStakeDialogOpen(true)}}>SWAP</Button>

    </Paper>


    

    <Menu
      anchorEl={anchorEl}
      open={isOpenMenu}
      onClose={handleClose}
    >
      <MenuItem onClick={() => handleMenuItemClick('vet', to_coin != 'usdt' ? 'to' : 'from' )}>VET</MenuItem>
      <MenuItem onClick={() => handleMenuItemClick('win', to_coin != 'usdt' ? 'to' : 'from')}>WIN</MenuItem>
      <MenuItem onClick={() => handleMenuItemClick('open', to_coin != 'usdt' ? 'to' : 'from')}>OPEN</MenuItem>
      <MenuItem onClick={() => handleMenuItemClick('metaland', to_coin != 'usdt' ? 'to' : 'from')}>METALAND</MenuItem>
      <MenuItem onClick={() => handleMenuItemClick('trx', to_coin != 'usdt' ? 'to' : 'from')}>TRON</MenuItem>
      <MenuItem onClick={() => handleMenuItemClick('xun', to_coin != 'usdt' ? 'to' : 'from')}>XUN</MenuItem>
    </Menu>

    <Dialog className='dilog_popup' open={stakedialogopen} onClose={handleClose}>
        <DialogTitle>Swap Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter your PIN to continue
          </DialogContentText>
          
        <TextField
            margin="dense"
            id="name"
            label="Secret Pin"
            type="password"
            fullWidth
            variant="standard"
            value={pin}
            onChange={(event) => setPin(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={SwapCoin}>Submit</Button>
        </DialogActions>
      </Dialog>
    
      </>
      
      )
  }
  
  export default Swap

